export const CPANEL_ACTIONS = {
  SET_LOADING: "SET_LOADING",
};
